import { h, Host } from "@stencil/core";
/** @internal */
export class Popper {
    render() {
        return h(Host, { key: 'a3e48a2d78d2d4f6e9c706c78eacfa83d6742e65' });
    }
    static get is() { return "es-popper-y"; }
}
//# sourceMappingURL=es-popper-y.js.map
